import React from 'react';

const PitcherCard = ({ label, name, stats, color }) => (
  <div className={`flex-1 border border-[#658d71] p-3 bg-[rgba(0,0,0,0.1)] border-l-4`} style={{ borderLeftColor: color }}>
    <span className="text-[9px] uppercase tracking-widest font-bold text-[#658d71]">{label}</span>
    <p className="text-sm font-black uppercase tracking-wide text-white mt-0.5 truncate">{name || '--'}</p>
    {stats && (
      <div className="flex gap-3 mt-1.5">
        {Object.entries(stats).map(([k, v]) => (
          <div key={k} className="flex flex-col items-center">
            <span className="text-[9px] text-[#658d71] uppercase tracking-widest font-bold">{k}</span>
            <span className="text-xs font-black text-[#d8ceb3] tabular-nums">{v ?? '--'}</span>
          </div>
        ))}
      </div>
    )}
  </div>
);

const RecapDecisions = ({ game, feed }) => {
  const decisions = game?.decisions || feed?.liveData?.decisions;
  const boxscore = feed?.liveData?.boxscore;

  const getPitcherStats = (personId) => {
    if (!boxscore || !personId) return null;
    for (const side of ['away', 'home']) {
      const players = boxscore.teams?.[side]?.players || {};
      const key = `ID${personId}`;
      if (players[key]) {
        const p = players[key].stats?.pitching;
        return p ? { IP: p.inningsPitched, K: p.strikeOuts, ER: p.earnedRuns, BB: p.baseOnBalls } : null;
      }
    }
    return null;
  };

  if (!decisions) return null;

  return (
    <div>
      <p className="text-[10px] text-[#658d71] uppercase tracking-widest mb-3 font-bold">Pitching Decisions</p>
      <div className="flex gap-3 flex-wrap sm:flex-nowrap">
        <PitcherCard
          label="Win"
          name={decisions.winner?.fullName}
          stats={getPitcherStats(decisions.winner?.id)}
          color="#a9c9b1"
        />
        <PitcherCard
          label="Loss"
          name={decisions.loser?.fullName}
          stats={getPitcherStats(decisions.loser?.id)}
          color="#c4333e"
        />
        {decisions.save?.id && (
          <PitcherCard
            label="Save"
            name={decisions.save?.fullName}
            stats={getPitcherStats(decisions.save?.id)}
            color="#d8ceb3"
          />
        )}
      </div>
    </div>
  );
};

export default RecapDecisions;